import React, { useState } from 'react';

import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';

/**
 * プロパティ
 */
export type Props = {
  /** 登録 */
  registration: ServiceWorkerRegistration,
};

const ServiceWorkerUpdateDialog: React.FC<Props> = (props: Props) => {
  const { registration } = props;
  const [show, setShow] = useState(!!registration.waiting);
  const handleUpdate = () => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
    setShow(false);
  };

  return (
    <Dialog open={show}>
      <DialogTitle style={{ textAlign: 'center' }}>
        ソフトウェア更新
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          ソフトウェアが更新されました
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleUpdate}>アップデート</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceWorkerUpdateDialog;
